import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { CmsModule } from '@fcom/cms';

import { KidsInBusinessNotificationComponent } from './kids-in-business-notification.component';

@NgModule({
  imports: [CommonModule, PipesModule, UiTranslateModule, UiComponentsModule, CmsModule],
  declarations: [KidsInBusinessNotificationComponent],
  exports: [KidsInBusinessNotificationComponent],
})
export class KidsInBusinessNotificationModule {}
